import { Injectable } from "@angular/core";

import { FileTranslationsStore } from "./file-translations.store";
import { addEntities, deleteEntities } from "@ngneat/elf-entities";
import { FileTranslation } from "./file-translation.model";

@Injectable({ providedIn: "root" })
export class FileTranslationsService {
	constructor(private fileTranslationsStore: FileTranslationsStore) {}

	removeTranslations = (translations: FileTranslation[]) => {
		this.fileTranslationsStore.store.update(deleteEntities(translations.map((x) => x.id)));
	};

	add(fileTranslation: FileTranslation) {
		this.fileTranslationsStore.store.update(addEntities(fileTranslation));
	}

	remove(id: string) {
		this.fileTranslationsStore.store.update(deleteEntities(id));
	}
}
